@if (titleKey() && titleKey() !== 'private.breadcrumb.home') {
  <section aria-label="page header" class="mt-[calc(var(--private-toolbar-height,56px)+1.3rem)] px-4 md:px-6 mb-2 md:mb-3">
    <div class="flex items-center gap-4 min-h-[56px] animate-page-header">
      @if (previousUrl()) {
        <button
          type="button"
          (click)="goBack()"
          [attr.aria-label]="backLabelKey | translate"
          class="back-btn inline-flex items-center gap-1.5 px-2.5 py-2 rounded-md border w-auto whitespace-nowrap"
          id="btn-back"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M15 18 L9 12 L15 6" stroke="currentColor" stroke-width="2" />
          </svg>
          <span class="text-sm font-medium">{{ backLabelKey | translate }}</span>
        </button>
      }

      <div class="flex flex-col flex-1 min-w-0">
        @if (titleKey()) {
          <h2 class="page-title">{{ titleKey() | translate }}</h2>
        }

        @if (subtitleKey()) {
          <p class="page-subtitle">{{ subtitleKey() | translate }}</p>
        }
      </div>

      <!-- Ações contextuais do cabeçalho (ex.: botão "?" de tutoriais do onboarding) -->
      <div class="shrink-0">
        <ng-container [ngTemplateOutlet]="headerActions" />
      </div>
    </div>
  </section>
} @else {
  <!-- Início não tem cabeçalho: o "?" de ajuda flutua no canto, sem empurrar o conteúdo -->
  <section aria-label="page header" id="page-header-home-actions" class="relative h-0 z-10">
    <div class="absolute right-4 md:right-6 top-[calc(var(--private-toolbar-height,56px)+0.5rem)]">
      <ng-container [ngTemplateOutlet]="headerActions" />
    </div>
  </section>
}

<ng-template #headerActions><ng-content /></ng-template>
